import { queryToSearch } from '@bibliocommons/utils-routing';
import { setCookie } from '@bibliocommons/utils-browser';

export default function redirectMiddleware() {
  return next => action => {
    const url = action.payload?.forceRedirectURL || action.forceRedirectURL;

    if (url && __CLIENT__) {
      const { method, data } = action;

      if (url.startsWith('/user/login')) {
        const PRE_LOGIN_URL_COOKIE = 'pre_login_url';
        setCookie(PRE_LOGIN_URL_COOKIE, window.location.href, { path: '/' });
      }

      if (method?.toUpperCase() === 'POST') {
        const form = Object.assign(document.createElement('form'), {
          method: 'post',
          action: url
        });

        Object.entries(data).forEach(([name, value]) => {
          form.appendChild(
            Object.assign(document.createElement('input'), {
              type: 'hidden',
              name,
              value
            })
          );
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        window.location.href = `${url}${queryToSearch(data)}`;
      }
      return;
    }

    // eslint-disable-next-line consistent-return
    return next(action);
  };
}
